<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { IconInfo } from '@/components/icons'
import { useStore } from '@/stores/store'
import { storeToRefs } from 'pinia'
import { onMounted, ref } from 'vue'

const store = useStore()
const { crossTopSewing, isStitches } = storeToRefs(store)

const contactUsHref = ref('/')
onMounted(() => {
  if(import.meta.env.PROD && window?.BASE_URL) {
    contactUsHref.value = window.BASE_URL + 'contact'
  }
})
</script>
<template>
  <transition name="modal">
    <div class="modal-mask" v-if="isStitches === 'stitches_yes'">
      <div class="fabrics-list-wrapper space-y-6 lg:space-y-10">
        <fieldset class="form-padding space-y-2">
          <legend class="font-semibold text-lg lg:text-xl">
            {{ $t('Do you want a cross top sewing?') }}
          </legend>
          <div class="form-part stitches-part">
            <div class="form-group flex gap-2">
              <label class="simple-radio" for="cross_top_sewing_yes">
                <div class="distribution-sample">
                  <img src="" />
                </div>
                <input
                  id="cross_top_sewing_yes"
                  v-model="crossTopSewing"
                  required
                  type="radio"
                  class="radio-input"
                  value="cross_top_sewing_yes"
                  name="crossTopSewing"
                />

                <span class="check-text">{{ $t('Yes') }}</span>
              </label>
              <label class="simple-radio" for="cross_top_sewing_no">
                <div class="distribution-sample">
                  <img src="" />
                </div>
                <input
                  id="cross_top_sewing_no"
                  v-model="crossTopSewing"
                  required
                  type="radio"
                  class="radio-input"
                  value="cross_top_sewing_no"
                  name="crossTopSewing"
                />

                <span class="check-text">{{ $t('No') }}</span>
              </label>
            </div>
          </div>
        </fieldset>
        <div
          class="contact-form-link flex flex-col items-start bg-black/80 px-6 py-4 text-white w-full max-w-[480px] space-y-4"
        >
          <div class="flex gap-2 justify-center items-center">
            <IconInfo class="text-white w-6" />
            <span class="w-full">{{
              $t('If you want another arrangement of top sewing, then please contact us')
            }}</span>
          </div>
          <a :href="contactUsHref" target="_blank" rel="noopener noreferrer" class="underline hover:text-white">{{ $t('Contact us') }}</a>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped></style>
